export default __webpack_public_path__ + "static/resume-c006275dea3b896528e7c1bd770fe7a1.pdf";